import React from "react";
import QuotationMarkVector from "../../images/quotation_marks.svg"

export default function QuoteCard({ body, name, standing }) {
  return (
    <div className="mr-3 ml-3 h-full bg-tint rounded-md">
      <div className="h-full min-w-h flex flex-col p-6">
        <div className="mb-5">
          <img src={QuotationMarkVector}></img>
        </div>
        <div className="flex flex-wrap h-full tracking-wide mb-5">
          <p>{body}</p>
        </div>
        <div className="flex flex-row">
          <span className="text-xs ml-auto mr-5">
            {name} | {standing}
          </span>
        </div>
      </div>
    </div>
  );
}
